import React from "react";
import ReactDOMServer from "react-dom/server";
import {
  InfoTable,
  SectionTitle,
  formatDate,
  money,
} from "./BnplFreezePDFUtils";

export default function BnplFreezePDFFooterStatic({ freeze, detail, flight }) {
  const miniRules = flight?.miniRules || [];
  const refundRule = miniRules.find((rule) => rule?.category === "REFUND");
  const exchangeRule = miniRules.find((rule) => rule?.category === "EXCHANGE");

  const content = (
    <table className="w-full" cellPadding="0" cellSpacing="0">
      <tbody>
        <tr>
          <td>
            <SectionTitle>9. Fare Conditions</SectionTitle>
            <InfoTable
              rows={[
                {
                  label: "Refund",
                  value: flight?.isRefundable
                    ? `Refundable${
                        refundRule?.maxPenaltyAmount
                          ? ` · max penalty ${refundRule.maxPenaltyAmount}`
                          : ""
                      }`
                    : "Not refundable",
                },
                {
                  label: "Flight Change",
                  value: flight?.isChangeable
                    ? `Changeable${
                        exchangeRule?.maxPenaltyAmount
                          ? ` · max penalty ${exchangeRule.maxPenaltyAmount}`
                          : ""
                      }`
                    : "Not changeable",
                },
              ]}
            />

            <SectionTitle>10. Important Payment Information</SectionTitle>
            <table
              className="w-full mb-3 text-xs border border-gray-200"
              cellPadding="0"
              cellSpacing="0"
            >
              <tbody>
                <tr>
                  <td className="px-3 py-3 text-gray-700 bg-gray-50">
                    This order was purchased under an Intraverse Price Freeze /
                    BNPL arrangement.
                  </td>
                </tr>
              </tbody>
            </table>
            <InfoTable
              rows={[
                {
                  label: "Flight Customer Payable",
                  value: money(flight?.customerPayable),
                },
                {
                  label: "Frozen Amount",
                  value: money(freeze?.frozenAmount),
                },
                { label: "Service Fee", value: money(freeze?.serviceFee) },
                {
                  label: "BNPL Repayment",
                  value: money(freeze?.loanedAmount),
                },
                {
                  label: "Outstanding",
                  value: money(
                    Number(detail?.remainingAmount) === 0
                      ? 0
                      : detail?.remainingAmount,
                  ),
                },
              ]}
            />

            <SectionTitle>11. Order References</SectionTitle>
            <InfoTable
              rows={[
                {
                  label: "Price Freeze Reference",
                  value: freeze?.reference,
                },
                { label: "Price Freeze ID", value: freeze?._id },
                { label: "Flight ID", value: flight?._id },
                { label: "Booking ID", value: flight?.bookingId },
                { label: "Airline PNR", value: flight?.pnr },
                {
                  label: "Payment Plan ID",
                  value: freeze?.freezeTravelPaymentPlanId,
                },
                {
                  label: "Freeze Booking ID",
                  value: freeze?.freezeTravelBookingId,
                },
                {
                  label: "Approved Date",
                  value: formatDate(freeze?.approvedDate),
                },
              ]}
            />

            <table
              className="w-full mt-6 pt-3 border-t border-gray-300"
              cellPadding="0"
              cellSpacing="0"
            >
              <tbody>
                <tr>
                  <td className="pt-4">
                    <div className="text-xs font-bold text-gray-800 tracking-wide">
                      INTRAVERSE AFRICA
                    </div>
                    <div className="text-xs text-gray-500 mt-1">
                      Travel products. Payments. Operations.
                    </div>
                    <div className="text-xs text-gray-500 italic mt-2">
                      This report contains confidential booking and passenger
                      information. Share only with authorised parties.
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
    </table>
  );

  return ReactDOMServer.renderToStaticMarkup(content);
}
